document.addEventListener('DOMContentLoaded', function () {
  function getSearchParameters() {
    var prmstr = window.location.search.substr(1);
    return prmstr != null && prmstr != "" ? transformToAssocArray(prmstr) : {};
  }

  function transformToAssocArray( prmstr ) {
    var params = {};
    var prmarr = prmstr.split("&");
    for ( var i = 0; i < prmarr.length; i++) {
        var tmparr = prmarr[i].split("=");
        params[tmparr[0]] = tmparr[1];
    }
    return params;
  }

  function serializeParameters (obj) {
    var str = [];
    for (var p in obj)
      if (obj.hasOwnProperty(p)) {
        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
      }
    return str.join("&");
  }

  function onClickFavorite (e) {
    var likeButton = e.currentTarget;
    var ringId = likeButton.dataset.ringId;
    var ringName = likeButton.dataset.ringName;
    var url = likeButton.dataset.favoritesUrl;
    var isLiked = likeButton.dataset.isLiked;
    var token = $('meta[name="csrf-token"]').first().attr("content");
    var isLikedTitle = ringName + "をお気に入り解除する";
    var isNotLikedTitle = ringName + "をお気に入り登録する";
    var paramsObject = getSearchParameters();

    paramsObject["ring_id"] = ringId

    $.ajax({
      type: isLiked === "true" ? "DELETE" : "POST",
      url: url,
      data: { "ring_id": ringId },
      dataType: "json",
      xhrFields: { withCredentials: true },
      beforeSend: function(xhr) {
        xhr.setRequestHeader("X-CSRF-Token", token);
      }
    })
    .done(function (r) {
      if (r["redirect"]) {
        var lastPageUrl = window.location.pathname + "?" + serializeParameters(paramsObject)
        var redirectUrl = r["redirect"] + "?" + $.param({ last_page_url: lastPageUrl, login_action: "add_favorite" });
        window.location.href = redirectUrl;
      } else if (r["ring_created"]) {
        likeButton.dataset.isLiked = "true";
        likeButton.setAttribute("title", isLikedTitle);
      } else if (r["ring_deleted"]) {
        likeButton.dataset.isLiked = "false";
        likeButton.setAttribute("title", isNotLikedTitle);
      } else {
        console.warn("something is wrong", r);
      }
    })
    .fail(function (e) {
      console.warn("Error: ", e);
    })

  }

  var customerFavorites = $(".js-changeFavorite");
  if (customerFavorites.length) {
    customerFavorites.each(function () {
      this.addEventListener("click", onClickFavorite, false)
    });
  }
}, false);

//
// リングのweb_messageのread more
// .js-collapseDescriptionがなければ作動しない
//
(function () {
  const breakpoint = 900; // viewportがこれ以上なら折りたたまない
  const line_number_threshold = 5; // 行数がこれ以上になると折りたたむ
  const $collapseDescription = $('.js-collapseDescription');
  const $innerElement = $collapseDescription.find('.js-collapseDescriptionContents');
  const $readMoreButton = $('.js-descriptionOpenBtn');
  let lastWindowWidth = null; // 初期ウィンドウ幅の記録

  if (!$collapseDescription.length) return;

  // デバウンス関数
  function debounce(func, wait) {
    let timeout;
    return function() {
      const context = this, args = arguments;
      const later = function() {
        timeout = null;
        func.apply(context, args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  // 行数を計算する関数
  function getNumberOfLines(el) {
    const computedStyle = window.getComputedStyle(el);
    const lineHeight = parseInt(computedStyle.lineHeight, 10);
    const height = el.clientHeight;

    return Math.round(height / lineHeight);
  }

  // リサイズイベントのハンドラ
  function handleResize() {
    const windowWidth = $(window).width();

    // 横幅が変わっていなければ何もしない（初回ロード時を除く）
    if (lastWindowWidth !== null && windowWidth === lastWindowWidth) return;
    lastWindowWidth = windowWidth; // 新しい横幅を記録

    // 一度開いたら折りたたまない
    if ($collapseDescription.hasClass("is-opend")) return;

    // p-description__innerの高さで行数を判定
    const numberOfLines = getNumberOfLines($innerElement.get(0));

    if (windowWidth >= breakpoint || numberOfLines < line_number_threshold) {
      // 900px以上、または5行未満の場合は開いた状態にする
      $collapseDescription.removeClass('is-collapsed');
      $readMoreButton.fadeOut();
    } else if (numberOfLines >= line_number_threshold) {
      // 900px未満で行数が5行以上の場合は折りたたむ
      $readMoreButton.fadeIn();
      $collapseDescription.addClass('is-collapsed');
    }
  }

  // Read More ボタンのクリックイベント
  $readMoreButton.on('click', function() {
    $collapseDescription.animate({
      height: $innerElement.get(0).scrollHeight
    }, 500, function() {
      $(this).removeClass('is-collapsed').addClass('is-opend').css('height', '');
    });
    $(this).fadeOut();
  });

  // デバウンス関数を使ってリサイズイベントを設定
  const debouncedResize = debounce(handleResize, 250);
  $(window).on('load resize', debouncedResize);

  // 初期ロード時にも実行
  handleResize();

})();
